import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { Icon, Typography } from '..'
import { util } from '../../../util'
import { useToggle } from '../../CustomHooks'
import { strings } from '../../../context/LanguageContext/strings'

const PreviewDetails = ({ data, breakAt, enableShowMore = false, className }) => {
    const [isShowMore, setShowMore] = useToggle(false)

    const PreviewItems = ({ data }) => (
        <div className={'preview-details__items flex'}>
            {data
                .sort((a, b) => a.order - b.order)
                .map(({ order, value, title, render, isHidden = false }) => {
                    const itemClassName = util.joinClasses(
                        'preview-details__items--item',
                        breakAt && order === breakAt && 'break',
                        isHidden && 'hide-item',
                        isShowMore && isHidden && 'show-hidden'
                    )
                    return (
                        <div className={itemClassName} key={title}>
                            <Typography
                                className={'mb-3'}
                                text={title}
                                fontType={'medium'}
                                size={'md'}
                            />
                            {value ? (
                                <Typography text={value} size={'sm'} />
                            ) : (
                                render && (
                                    <div className={'preview-item-icon-container'}>{render()}</div>
                                )
                            )}
                        </div>
                    )
                })}
        </div>
    )

    return (
        <div data-testid={'preview-details'} className={`preview-details ${className}`}>
            <PreviewItems data={data} />
            {enableShowMore && (
                <div className={'preview-details__show-more mt-4 flex-row'} onClick={setShowMore}>
                    <Typography
                        text={isShowMore ? strings.SHOW_LESS : strings.SHOW_MORE}
                        color={'dark'}
                        isUnderline={true}
                        hover={'pointer'}
                    />
                    <Icon
                        pointer={true}
                        renderIcon={isShowMore ? util.ArrowDropUpIcon : util.ArrowDropDownIcon}
                        color={'success'}
                        margin={'ml-0 mr-0'}
                    />
                </div>
            )}
        </div>
    )
}

PreviewDetails.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            order: PropTypes.number.isRequired,
            value: PropTypes.any,
            isHidden: PropTypes.bool,
            render: PropTypes.func,
        })
    ),
    /**
     * Breaks the grid the column at the provided breakAt value
     */
    breakAt: PropTypes.number,
    enableShowMore: PropTypes.bool,
    className: PropTypes.string,
}

export default memo(PreviewDetails)
